import React from "react";

import { Btn, BtnType } from "@/mk2/components/Btn";
import { Form } from "@/mk2/components/Form";
import { InputField } from "@/mk2/components/forms/InputField";
import { SubmitButton } from "@/mk2/components/forms/SubmitButton";
import { MKReduxFormInjectedProps, mkReduxForm } from "@/mk2/decorators/mkReduxForm";
import { CANCEL, SAVE_DESCRIPTION } from "@/mk/autogenerated/translation";

import styles from "./PhotoTitleEditForm.mscss";

export const photoTitleEditFormName = (imageId: number) => `PHOTO_TITLE_EDIT_FORM_${imageId}`;

export interface PhotoTitleFormData {
    title: string;
}

interface OwnProps {
    initialValues: PhotoTitleFormData;
    onCancel();
    onSave(values: PhotoTitleFormData);
}

type Props = OwnProps;

class PhotoTitleEditFormComponent extends React.PureComponent<
    Props & MKReduxFormInjectedProps<PhotoTitleFormData, Props>
> {
    public render() {
        const { form, handleSubmit, onCancel } = this.props;

        return (
            <Form onSubmit={handleSubmit}>
                <InputField autoFocus minimizedLabel name="title" type="text" maxLength={250} />

                <SubmitButton
                    className={styles.PhotoTitleEditForm__submitBtn}
                    formName={form}
                    label={SAVE_DESCRIPTION}
                />

                <Btn
                    className={styles.PhotoTitleEditForm__cancelBtn}
                    label={CANCEL}
                    onClick={onCancel}
                    type={BtnType.GreyText}
                />
            </Form>
        );
    }
}

export const PhotoTitleEditFormFactory = (formName: string) =>
    mkReduxForm<PhotoTitleFormData, Props>({
        formName,
        onValidate: () => ({
            /* nothing to do, always valid */
        }),
        onSave: (values, props) => props.onSave(values),
    })(PhotoTitleEditFormComponent);
